import { formatNestedAttributeKey } from '@shared/workflow/formatNestedAttributeKey.js';

const getStepArrayOptions = (steps) => {
  const options = steps.map((step) => {
    const children = step.attributes
      ?.filter((attr) => attr.dataType === 'array' || attr.dataType === 'object[]') //
      .map((attr) => ({ value: { type: 'arrayMap', stepId: step.value, attributeKey: attr.key?.startsWith(step.arrayMapKey) ? attr.key?.replace(`${step.arrayMapKey}.`, '') : attr.key, parentKey: step.arrayMapKey }, label: formatNestedAttributeKey(attr.key) }));

    if (step.value !== 'system') {
      children.unshift({ value: { type: 'arrayMap', stepId: step.value, attributeKey: 'input', parentKey: step.arrayMapKey }, label: 'Select Entire Output' });
    }

    return {
      value: step.value,
      label: (
        <>
          <span className="step-number">{step.stepNumber}</span>
          <span className="step-name">{step.name}</span>
        </>
      ),
      icon: step.icon,
      children
    };
  });

  return options.filter((option) => option.children?.length > 0);
};

export default getStepArrayOptions;
